// extracted by mini-css-extract-plugin
export default {"transition":"_4c0fb08a"};